<template>
	<FormSearchableInput2
		ref="searchable"
		:selected="selected"
		:list="searchList"
		:is-search-loading="isLoading"
		v-bind="$attrs"
		:search="handleSearch"
		@update:text="$emit('update:text', $event)"
		@update:selected="$emit('update:selected', $event)"
	/>
</template>
<script>
import Partners from "@/API/Partners.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSearchableInput2 from "@/components/FormSearchableInput2.vue"

export default {
	name: "SelectPartner",
	mixins: [LoadingMixins],
	model: {
		prop: 'selected',
		event: 'update:selected'
	},
	props: {
		selected: [Object, Number, String],
		disabled: Boolean,
	},
	components: {
		FormSearchableInput2
	},
	data() {
		return {
			searchList: []
		}
	},
	methods: {
		/**
		 *
		 * @param search
		 */
		async handleSearch(search) {
			const [err, res] = await Partners.getSelect({search})

			if (err) {
				// TODO...
				return []
			}

			return res.data.data
		},
		focus() {
			this.$refs.searchable.focus()
		},
		clear() {
			this.$refs.searchable.clear()
		}
	}
}
</script>